import React from 'react';
import { formatValue, clearValue } from '../../utils';

export default class PreviousPayslips extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            gross: 0,
            epf: 0,
            socso: 0,
            pcb: 0,
        };

        this.state = this.initialState;
        this.onChange = null;
    }

    handleRawChange = (type, value) => {
        clearTimeout(this.onChange);

        const newState = Object.assign({},
            this.state,
            {
                [type]: value
            }
        );

        this.onChange = setTimeout(this.handleChange, 1000);
        this.setState(newState);
    }

    handleChange = () => {
        const { gross, epf, socso, pcb } = this.state;

        const newState = Object.assign({},
            this.state,
            {
                gross: formatValue(gross),
                epf: formatValue(epf),
                socso: formatValue(socso),
                pcb: formatValue(pcb)
            }
        );

        const clearedState = Object.assign({},
            newState,
            {
                gross: clearValue(newState.gross),
                epf: clearValue(newState.epf),
                socso: clearValue(newState.socso),
                pcb: clearValue(newState.pcb),
                isCheckboxVisible: undefined // unused field
            }
        );

        this.props.handleChange(clearedState);
        this.setState(newState);
    }

    render() {
        const { gross, epf, socso, pcb } = this.state;

        return (
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='group-title' style={{marginBottom: 0}}>
                        <label>
                            Previous Payslips <i
                                className="fa fa-question-circle"
                                data-tip="Current year previous payslip data must be included for accurate PCB calculations - <br />
                                see <a href='http://help.payrollpanda.my/18570-app-faq/192168-how-is-pcb-calculated-by-the-app' target='_blank'>this</a> help article for more info. If previous payslips fields are left blank, <br />
                                it will be assumed that no previous salary was received during the year. To calculate <br />
                                PCB for a recurring monthly income without needing to input previous payslips, please <br />
                                set the month to January."
                            ></i>
                        </label>
                    </div>
                </div>

  
                    <div className='col-sm-12'>
                        <div className='row'>
                            <div className='col-sm-12 col-md-6 col-xl-4'>
                                <div className='pcb-input'>
                                    <label>
                                        PREVIOUS SALARY TOTAL
                                    </label>

                                    <input
                                        type='text'
                                        placeholder='Your previous total salary (RM)'
                                        value={gross}
                                        onChange={event =>
                                            this.handleRawChange(
                                                'gross', event.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>

                            <div className="w-100 d-none d-xl-block"></div>

                            <div className='col-sm-12 col-md-6 col-xl-4'>
                                <div className='pcb-input'>
                                    <label>
                                        PREVIOUS PCB
                                    </label>

                                    <input
                                        type='text'
                                        placeholder='Your previous PCB paid (RM)'
                                        value={pcb}
                                        onChange={event =>
                                            this.handleRawChange(
                                                'pcb', event.target.value

                                            )
                                        }
                                    />
                                </div>
                            </div>

                            <div className='col-sm-12 col-md-6 col-xl-4'>
                                <div className='pcb-input'>
                                    <label>
                                        PREVIOUS EMPLOYEE EPF
                                    </label>

                                    <input
                                        type='text'
                                        placeholder='Your previous EPF paid (RM)'
                                        value={epf}
                                        onChange={event =>
                                            this.handleRawChange(
                                                'epf', event.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>

                            <div className='col-sm-12 col-md-6 col-xl-4'>
                                <div className='pcb-input'>
                                    <label>
                                        PREVIOUS EMPLOYEE SOCSO
                                    </label>

                                    <input
                                        type='text'
                                        placeholder='Your previous SOCSO paid (RM)'
                                        value={socso}
                                        onChange={event =>
                                            this.handleRawChange(
                                                'socso', event.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/PreviousPayslips.js